import * as React from 'react';
import './ToggleSwitch.scss';

interface IToggleSwitchProps {
  enabled: boolean;
  handleOnButtonChange(): void;
}

export class ToggleSwitch extends React.Component<IToggleSwitchProps, any> {
  constructor(props: any) {
    super(props);
  }

  private handleOnChange = () => {
    this.props.handleOnButtonChange();
  };

  public render() {
    return (
      <label className="rp-switch switch" aria-label="Hide product price and only show product MSRP">
        <input
          type="checkbox"
          onClick={this.handleOnChange}
          defaultChecked={this.props.enabled}
        />
        <span className="slider round" />
      </label>
    );
  }
}

export default ToggleSwitch;
